import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { HomePage, EventsPage as PublicEventsPage, CodeOfConductPage, GeneralInstructionsPage, VenueMapPage } from './features/public';
import { LoginPage } from './features/auth/LoginPage';
import { DashboardPage, LogsPage, SchoolsPage, EventsPage, RegistrationsPage, ResultsPage, AccessKeysPage, AdminsPage, ParticipantsPage } from './features/admin';
import { DashboardPage as SchoolDashboardPage, RegisterParticipantsPage, TeamPage, ResultsPage as SchoolResultsPage } from './features/school';
import { ProtectedRoute } from './components/common/ProtectedRoute';
import { AdminLayout } from './components/layout/AdminLayout';
import { SchoolLayout } from './components/layout/SchoolLayout';



const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/events" element={<PublicEventsPage />} />
          <Route path="/code-of-conduct" element={<CodeOfConductPage />} />
          <Route path="/instructions" element={<GeneralInstructionsPage />} />
          <Route path="/venue-map" element={<VenueMapPage />} />

          {/* Admin Routes */}
          <Route path="/admin/*" element={
            <ProtectedRoute type="admin">
              <AdminLayout>
                <Routes>
                  <Route path="dashboard" element={<DashboardPage />} />
                  <Route path="logs" element={<LogsPage />} />
                  <Route path="schools" element={<SchoolsPage />} />
                  <Route path="events" element={<EventsPage />} />
                  <Route path="registrations" element={<RegistrationsPage />} />
                  <Route path="results" element={<ResultsPage />} />
                  <Route path="keys" element={<AccessKeysPage />} />
                  <Route path="admins" element={<AdminsPage />} />
                  <Route path="participants" element={<ParticipantsPage />} />
                  <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Routes>
              </AdminLayout>
            </ProtectedRoute>
          } />

          {/* School Routes */}
          <Route path="/school/*" element={
            <ProtectedRoute type="school">
              <SchoolLayout>
                <Routes>
                  <Route path="dashboard" element={<SchoolDashboardPage />} />
                  <Route path="register" element={<RegisterParticipantsPage />} />
                  <Route path="team" element={<TeamPage />} />
                  <Route path="results" element={<SchoolResultsPage />} />
                  <Route path="*" element={<Navigate to="dashboard" replace />} />
                </Routes>
              </SchoolLayout>
            </ProtectedRoute>
          } />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
};

export default App;
